import { render, staticRenderFns } from "./FbSubmitError.vue?vue&type=template&id=6cc3a482&scoped=true"
import script from "./FbSubmitError.vue?vue&type=script&lang=js"
export * from "./FbSubmitError.vue?vue&type=script&lang=js"
import style0 from "./FbSubmitError.vue?vue&type=style&index=0&id=6cc3a482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc3a482",
  null
  
)

export default component.exports